module.exports = __webpack_public_path__ + "static/img/zmlogo.9562395.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zmlogo.png
// module id = or7B
// module chunks = 134